module.exports = __webpack_public_path__ + "media/images/meta/stretchlab_aus/apple-touch-icon_alt-6c017d48c2a48b415d27205f20d30a0b.png";